const categories = {
  interaction: 'User Interaction',
  validation: 'Validation',
};

export default categories;
